import React, { Component } from 'react';
import { connect } from 'react-redux';

import Layout from '../../components/layout';
import Loading from '../../components/spinner';
import { Title } from '../../components/common';
import { withTranslation } from '../../lib/translate';
import { getPrivacyPolicy } from '../../store/actions';
import NoData from '../../components/noData';

import './index.css';
import { forwardTo, goBack } from '../../lib/utils';

class Privacy extends Component {
	componentDidMount() {
		this.props.dispatch(getPrivacyPolicy());
	}
	backHandler = () => {
		if (this.props.location?.state?.fromRegisterPage) {
			forwardTo('/register', { saveRegisterData: true });
		} else {
			goBack();
		}
	};
	render() {
		const { __, privacyPolicy } = this.props;
		return (
			<Loading>
				<Layout showHamburger={!this.props.location?.state?.fromRegisterPage} backHandler={this.backHandler} color="transparent" headerTitle={__('Privacy Policy')}>
					<div>
						<Title>{__('Privacy Policy')}</Title>
						{privacyPolicy ? <div dangerouslySetInnerHTML={{ __html: privacyPolicy }} /> : <NoData />}
					</div>
				</Layout>
			</Loading>
		);
	}
}

const stateToProps = (state) => {
	return {
		privacyPolicy: state.common.privacyPolicy || null,
	};
};

export default connect(stateToProps)(withTranslation(Privacy));
